export const getCustomBrokersList = (state) => state.mainSettings.customBrokersList;
export const getLicenseKey = (state) => state.mainSettings.licenseKey;
export const getLicenseKeyError = (state) => state.mainSettings.licenseKeyError;
export const getClientRate = (state) => state.mainSettings.clientRate;
export const isClientPRO = (state) => state.mainSettings.clientRate === "PRO";
export const isAuth = (state) => state.mainSettings.isAuth;
